import React from 'react';
import './styles.scss';

const Label = ({ label, required }) => {
	return (		
		<label 
			className="input-group__label"
			htmlFor={label}
		>
			{label}
			{required && '*'}
		</label>
	)
};

export default Label;
